import { Graphics } from "pixi.js";
import { NO_STATUS_LINE_COLOR, NO_STATUS_LINE_ALPHA } from "./PicSprite";
// import { DropShadowFilter } from '@pixi/filter-drop-shadow';

export class Pic extends Graphics {

  constructor(el, offset, layers, layerCAD, index, typeRegister) {
    super();

    this.picId = el.id.toString() // id del rectángulo
    this.picName = this._GetNameEntity(el, index) // nombre del rectángulo
    this.picX = parseFloat(Math.abs( el.x + offset.x )); // posición en x del rectángulo
    this.picY = parseFloat(Math.abs( el.y - offset.y )); // posición en y del rectángulo

    this.picWidth = el.width; // ancho del rectángulo
    this.picHeight = el.height; // alto del rectángulo
    this.picWithIssue = el.withIssue ? el.withIssue : false

    this.picFillColor = typeRegister === 'issue'
      ? this.picWithIssue ? '#fc0000' : '#f5f5f5'
      : this._GetColorStatusOfLayout(el, layers) //?? '#000000';

    this.picLineColor = typeRegister === 'issue' ? '#706f6f' : this._GetColorLayer(el.layer, layerCAD);
    this.picLineWidth = el.type == 'sections' || el.type == 'nodes' ? 0.5 : 0.15;
    // Línea gris mientras no tenga estado (no aplica a líneas de evacuación ni a registro de incidencias)
    this.picGrayLineWithoutStatus = typeRegister !== 'issue' && el.type != 'sections' && el.type != 'nodes';

    // this.picAlpha = this.picFillColor === '#000000' ? 0.1 : el.status == null ? 1 : 0.7, // 0..1
    this.picAlpha = this.picFillColor === '#000000' ? 0.1 : 0.7, // 0..1
    this.picVisible = true // flag para saber si el rectángulo esta visible

    this.picType = el.type // el tipo de entidad si es modulo, hincado, estrucutura, etc
    this.picLayerName = el.layer; // nombre de la capa a la que pertenece el rectángulo

    this.picPreviouStatus = el.so, // estado anterior
    this.picStatus = el.status ? (typeof el.status === 'object' ? el.status.id : el.status ) :  null; // estado actual este contiene el id del estado
    this.picStatusColor = this.picFillColor;  // color del estado

    this.picPreviouIncident = null;
    this.picIncident = el.incident ? el.incident : null;
    this.picIncidentColor = this._GetColorIncidentStatusOfLayout(el, layers);

    this.picColorHover = '#fff7b3' // color mostrado cuando el mouse esta sobre el rectángulo
    this.picOpacityHover = 0.3 // la opacidad del hover
    this.picColorSelected = '#90caf9' // color cuando el elemento está seleccionado (azul claro)
    this.picOpacitySelected = 0.6 // opacidad cuando está seleccionado
    this.picSelected = false // flag para saber si el rectángulo esta seleccionado

    this.picShowOperationalStatuses = false;
    this.interactive = true;
    // this.cursor = 'pointer';

    // variables para manejar el click doble en el pic
    this.lastClickTime = 0;
    this.doubleClickThreshold = 300; // 300ms
    this.clickTimeout = null;

    // Dibujar el rectángulo con los parámetros personalizados
    this.drawRectangle();

    // Hover se maneja individualmente, clicks via event delegation
    this.eventMode = 'static';
    this.on('pointerover', this._HandleMouseOver.bind(this));
    this.on('pointerout', this._HandleMouseOut.bind(this));
  }

  // Método para dibujar el rectángulo con los parámetros personalizados
  drawRectangle() {
    // Calcular el alpha final
    const finalAlpha = Math.max(0, Math.min(1, this.picAlpha ?? 0.7));
    this.alpha = finalAlpha;

    // Determinar color de relleno
    let fillColor = '#fefefe';
    if (this.picShowOperationalStatuses) {
      fillColor = this.picIncident ? this.picIncidentColor : '#fefefe';
    } else {
      fillColor = this.picFillColor || '#fefefe';
    }

    // Determinar stroke (color y ancho)
    let strokeWidth = this.picLineWidth;
    let strokeColor = this._hexStringToNumber(this.picLineColor) || 0x000000;
    let strokeAlpha = 1;

    // Sin estado: línea gris plomo semitransparente (con estado usa el color de la capa)
    if (this.picGrayLineWithoutStatus && this.picStatus == null) {
      strokeColor = this._hexStringToNumber(NO_STATUS_LINE_COLOR);
      strokeAlpha = NO_STATUS_LINE_ALPHA;
    }

    // Si tiene incidente, usar línea más gruesa con color del incidente
    if (this.picIncident && !this.picShowOperationalStatuses) {
      strokeWidth = 0.8;
      strokeColor = this._hexStringToNumber(this.picIncidentColor) || 0xff0000;
      strokeAlpha = 1;
    }

    // Dibujar rectángulo
    this.rect(this.picX, this.picY, this.picWidth, this.picHeight)
      .fill(fillColor)
      .stroke({ width: strokeWidth, color: strokeColor, alpha: strokeAlpha });
  }

  // Convierte color hex string (#ff0000) a número (0xff0000)
  _hexStringToNumber(hexString) {
    if (!hexString) return null;
    if (typeof hexString === 'number') return hexString;
    return parseInt(hexString.replace('#', ''), 16);
  }

  addEvents() {
    this.on('click', this._HandleClick);

    this.on('mouseover', this._HandleMouseOver);

    this.on('mouseout', this._HandleMouseOut);
  }

  // Método para cambiar el tamaño del rectángulo
  resize(width, height) {
    this.width = width;
    this.height = height;

    this.clear(); // Limpiar el rectángulo anterior
    this.drawRectangle(); // Dibujar el nuevo rectángulo
  }

  // Método para cambiar el color de relleno del rectángulo
  changeFillColor(color) {
    this.fillColor = color;
    this.clear(); // Limpiar el rectángulo anterior
    this.drawRectangle(); // Dibujar el nuevo rectángulo
  }

  _GetNameEntity(entity, index) {
    if ( entity.name != null )
      return entity.name

    return 'E.' + entity.type.charAt(0).toUpperCase() + '.' + (index + 1)

  }

  _GetColorStatusOfLayout(entity, layers) {
    if( entity.status != null ) {
      let lyr = layers.find( item => { return item.code === entity.type })
      if (lyr) {
        let idStatus = typeof entity.status === 'object' ? entity.status.id : entity.status;

        const statuses = [
          ...(lyr.statuses ?? []),
          // ...(lyr.incident_statuses ?? [])
        ];

        let status = statuses.find(item => { return item.id == idStatus })
        if (status)
          return status.color
      }
    }
    return null
  }

  _GetColorIncidentStatusOfLayout(entity, layers) {
    if( entity?.incident !== undefined && entity.incident !== null && entity.incident !== '' ) {
      let lyr = layers.find( item => { return item.code === entity.type })
      if (lyr) {
        let idStatus = typeof entity.incident === 'object' ? entity.incident.id : entity.incident;

        const statuses = [
          // ...(lyr.statuses ?? []),
          ...(lyr.incident_statuses ?? [])
        ];

        let status = statuses.find(item => { return item.id == idStatus })
        if (status)
          return status.color
      }
    }
    return null
  }

  _GetColorLayer(nameLayer, layers) {
    if (layers === undefined || layers === null || layers.length === 0)
      return '#000000'

    let layer = layers.find((l) => l.name === nameLayer)
    if (!layer) return '#000000'

    return this._GetCssColor(layer.color)
  }

  _GetCssColor(value) {
      let s = value.toString(16)
      while (s.length < 6) {
          s = "0" + s
      }
      return "#" + s
  }

  _HandleClick(e) {
    const currentTime = Date.now();
    const delta = currentTime - this.lastClickTime;

    if (this.clickTimeout) {
      clearTimeout(this.clickTimeout);
      this.clickTimeout = null;
    }

    if (delta < this.doubleClickThreshold) {
      this._HandleDoubleClick(e);
      this.lastClickTime = 0;
    } else {
      this.lastClickTime = currentTime;
      this.clickTimeout = setTimeout(() => {
        this._HandleSingleClick(e);
        this.clickTimeout = null;
      }, this.doubleClickThreshold);
    }
  }

  _HandleSingleClick(e) {
    // Obtener coordenadas globales del mouse en el stage de PixiJS
    // e.data.global contiene las coordenadas en el espacio del stage (ya incluye zoom y pan)
    let globalPos;

    if (e.data && e.data.global) {
      // Usar las coordenadas del evento del mouse (más preciso)
      globalPos = e.data.global;
    } else {
      // Fallback: calcular el centro del objeto
      const bounds = this.getBounds();
      const centerX = bounds.x + bounds.width / 2;
      const centerY = bounds.y + bounds.height / 2;
      globalPos = this.parent.toGlobal({ x: centerX, y: centerY });
    }

    this._Emit('show_info', {
      pic: {
        attrs: {
          id: this.picId,
          name: this.picName,
          type: this.picType,
          layerName: this.picLayerName,
          status: this.picStatus,
          statusColor: this.picStatusColor,
          previouStatus: this.picPreviouStatus,
          incident: this.picIncident,
          incidentColor: this.picIncidentColor,
          previouIncident: this.picPreviouIncident,
        },
      },
      x: globalPos.x,
      y: globalPos.y,
    });
  }

  _HandleDoubleClick(e) {
    // si esta en modo de visualizacion de incidencia no se puede seleccionar la entidad
    if (this.picShowOperationalStatuses) {
      this._Emit('incident_view_mode_active', false);
      return;
    }

    let el = e.target
    // if (! this.picSelected) {
    //   this.picSelected = true
    //   this.picFillColor = '#fff7b3'
    //   this.picAlpha = 0.6
    //   el.drawRectangle();
    // } else {
    //   this.picSelected = false
    //   this.picFillColor = this.picStatusColor

    //   this.picAlpha = this.picStatus ? 0.7 : 1
    //   el.drawRectangle();
    // }

    this.SelectPic(el)
    // console.log('Mensaje desde HanleOnLCick Se hizo clic en el rectángulo: ', this.picName);
  }

  _HandleMouseOver(e) {
    let el = e.target
    const hoverColor = this._hexStringToNumber(this.picColorHover);
    el.clear();
    el.rect(this.picX, this.picY, this.picWidth, this.picHeight)
      .fill({ color: hoverColor, alpha: this.picOpacityHover });
  }

  _HandleMouseOut(e) {
    let el = e.target

    // Si está seleccionado, mantener el color de selección
    if (this.picSelected) {
      this.picFillColor = this.picColorSelected;
      this.picAlpha = this.picOpacitySelected;
    } else {
      // Si no está seleccionado, restaurar al color del estado
      this.picFillColor = this.picStatusColor || '#fefefe';
      this.picAlpha = this.picStatus ? 0.7 : 1;
    }

    this.clear()
    el.drawRectangle();
  }

  SelectPic(el) {
    this.clear()
    if (!this.picSelected) {
      this.picSelected = true
      this.picFillColor = this.picColorSelected
      this.picAlpha = this.picOpacitySelected
      el.drawRectangle();
    } else {
      this.Deselect(el)
    }

    this._Emit('select', this)
  }

  Deselect(el) {
    this.picSelected = false
    this.picFillColor = this.picStatusColor

    this.picAlpha = this.picStatus ? 0.7 : 1
    el.drawRectangle();

    this._Emit('deselect', this)
  }

  _Emit(eventName, data = null) {
    document.dispatchEvent(new CustomEvent('__epc_pic_' + eventName, { detail: data }))
  }

  setPicStatus(status) {
    this.picStatus = status
  }

  setPicStatusColor(color) {
    this.picStatusColor = color
  }

  setPicPreviouStatus(status) {
    this.picPreviouStatus = status
  }

  setWithIssue(flag) {
    this.picWithIssue = flag
    this.fill( flag ? '#fc0000' : '#f5f5f5' )
  }

  setCurrentStatus(newStatus) {
    if (newStatus == null) {
      return;
    }

    if (newStatus.type === 'incident') {
      this.picIncident = newStatus.id;
      this.picIncidentColor = newStatus.color;
      // Para incidentes, también actualizamos el fillColor si es necesario
      if (newStatus.color) {
        this.picFillColor = newStatus.color;
      }
    } else {
      this.picStatus = newStatus.id;
      this.picStatusColor = newStatus.color;
      this.picFillColor = newStatus.color;
    }

    // Determinar alpha: siempre usar semi-transparente (0.7) cuando se actualiza el estado
    // Esto permite ver el rectángulo con transparencia adecuada independientemente del color
    this.picAlpha = 0.7;

    this.clear();
    this.drawRectangle();
  }

  /**
   * Aplica un nuevo estado desde la UI (LayersToolStatuses).
   * Mantiene sincronizados picStatus, picStatusColor y picFillColor.
   * @param {Object} status - El nuevo estado { id, color, type, ... }
   * @returns {boolean} - true si se aplicó el cambio, false si ya tenía el mismo estado
   */
  applyStatus(status) {
    const statusId = status?.id ?? null;
    const statusColor = status?.color ?? null;

    // Si ya tiene el mismo estado, deseleccionar y retornar false
    if (this.picStatus === statusId) {
      if (this.picSelected) {
        this.Deselect(this);
      }
      return false;
    }

    // Guardar estado anterior
    this.picPreviouStatus = this.picStatus;

    // Actualizar estado (mantener todo sincronizado)
    this.picStatus = statusId;
    this.picStatusColor = statusColor;
    this.picFillColor = statusColor;

    // Deseleccionar
    this.picSelected = false;
    this.picAlpha = 0.7;

    // Redibujar
    this.clear();
    this.drawRectangle();

    return true;
  }

  showOperationalStatus(show) {
    this.picShowOperationalStatuses = show;
    this.clear();
    this.drawRectangle();
  }
}
